/* eslint-disable eqeqeq */
import React, {  useEffect } from 'react'

import { ADMIN_GET_USER } from './Queries'
import { ThemeProvider, StyledEngineProvider } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import routes from '../navigation/routes'
import TabbedPage from '../navigation/Tabs/TabbedPage'
import theme from '../styles/muiThemes/adminConsoleTheme'
import UserQuickView from '../User/UserQuickView'
import { fetchWithAuth } from '../common/helpers'
import { DYNAMIC_USER_SEARCH } from '../Search/Queries'

function AdminConsole (props) {
	
	const params = useParams()
	const navigate = useNavigate()

	const adminRedirect = (url) => {
		fetchWithAuth(url)
			.then( resp => resp.json() )
			.then( data => {
				if (!data.isAdminAuthenticated){
					navigate('/admin/login')
				}
			} )	
	}

	useEffect(()=>{
		// redirect if the user is not logged in as admin. 
		const url = new URL("/api/admin-auth-status", window.location.origin)
		adminRedirect(url)
	})

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme} >
				{TabbedPage({
					...props,
					routes: routes.adminUserPages.pages,
					Quickview: UserQuickView,
					query: ADMIN_GET_USER,
					searchGlobalQuery: DYNAMIC_USER_SEARCH,
					options: routes.adminUserPages.options,
					params,
				}) }
			</ThemeProvider>
		</StyledEngineProvider>
	)
}

export default AdminConsole
